module.exports = __webpack_public_path__ + "a5e74dffad4e6da2ec743f8c2934b81d.glb";